/* eslint-disable max-len */
import { ReactNode } from 'react';
import { IconName } from './enums';

type IconAttributes = {
  viewBox: string;
  path: ReactNode;
};

export const getIconAttributes = (name: IconName, strokeWidth?: number): IconAttributes | undefined => {
  switch (name) {
    case IconName.Add:
      return {
        viewBox: '0 0 14 14',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M7 0V14" />
            <path d="M0 7H14" />
          </g>
        ),
      };

    case IconName.AddNotes:
      return {
        viewBox: '0 0 17 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="M3.5 8.5V16L7.5 12H16V3.5H8.5" />
            <path d="M3.5 1V6" strokeLinecap="square" />
            <path d="M6 3.5H1" strokeLinecap="square" />
          </g>
        ),
      };

    case IconName.Alert:
      return {
        viewBox: '0 0 18 17',
        path: (
          <>
            <path d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z" />
            <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
              <path d="M9 6.5V11" />
              <path d="M1 16L9 1L17 16H1Z" />
            </g>
          </>
        ),
      };

    case IconName.Archive:
      return {
        viewBox: '0 0 17 15',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M16 1H1V4H16V1Z" strokeLinecap="round" />
            <path d="M14 6V14H3V6" />
            <path d="M11 7H6V10H11V7Z" strokeLinecap="round" />
          </g>
        ),
      };

    case IconName.ArrowDown:
      return {
        viewBox: '0 0 12 13',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M6 0V12" />
            <path d="M1 7L6 12L11 7" />
          </g>
        ),
      };

    case IconName.ArrowLeft:
      return {
        viewBox: '0 0 13 12',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M13 6H1" />
            <path d="M6 1L1 6L6 11" />
          </g>
        ),
      };

    case IconName.ArrowRight:
      return {
        viewBox: '0 0 13 12',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M0 6H12" />
            <path d="M7 11L12 6L7 1" />
          </g>
        ),
      };

    case IconName.ArrowUp:
      return {
        viewBox: '0 0 12 13',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M6 1V13" />
            <path d="M11 6L6 1L1 6" />
          </g>
        ),
      };

    case IconName.ArrowUpNOut:
      return {
        viewBox: '0 0 12 12',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M11 1L1 11" />
            <path d="M4 1H11V8" />
          </g>
        ),
      };

    case IconName.Attach:
      return {
        viewBox: '0 0 16 18',
        path: (
          <path
            d="M8.85683 6.35715L5.85183 9.36215C5.16883 10.0451 5.16883 11.1531 5.85183 11.8371C6.53483 12.5201 7.64283 12.5201 8.32683 11.8371L12.3928 7.77115C13.7598 6.40415 13.7598 4.18815 12.3928 2.82115C11.0258 1.45415 8.80983 1.45415 7.44283 2.82115L3.02383 7.24115C0.973828 9.29115 0.973828 12.6151 3.02383 14.6661C5.07383 16.7161 8.39783 16.7161 10.4488 14.6661L14.5138 10.6001"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.Awarded:
      return {
        viewBox: '0 0 32 32',
        path: (
          <>
            <g strokeWidth={strokeWidth || 3} strokeMiterlimit="10" fill="none">
              <path d="M23.8313 15.7466L29.334 26.6666L24.0006 25.3333L21.334 29.3333L16.9673 19.9506" />
              <path d="M8.16966 15.7466L2.66699 26.6666L8.00033 25.3333L10.667 29.3333L15.0337 19.9506" />
              <path
                d="M16.0003 20C21.155 20 25.3337 15.8214 25.3337 10.6667C25.3337 5.51205 21.155 1.33337 16.0003 1.33337C10.8457 1.33337 6.66699 5.51205 6.66699 10.6667C6.66699 15.8214 10.8457 20 16.0003 20Z"
                strokeLinecap="square"
              />
              <path
                d="M15.9997 13.3334C17.4724 13.3334 18.6663 12.1395 18.6663 10.6667C18.6663 9.19397 17.4724 8.00006 15.9997 8.00006C14.5269 8.00006 13.333 9.19397 13.333 10.6667C13.333 12.1395 14.5269 13.3334 15.9997 13.3334Z"
                strokeLinecap="square"
              />
            </g>
          </>
        ),
      };

    case IconName.Bin:
      return {
        viewBox: '0 0 16 18',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M2 4V17H14V4" />
            <path d="M0 4H16" />
            <path d="M5 3V1H11V3" />
            <path d="M10 7V14" />
            <path d="M6 7V14" />
          </g>
        ),
      };

    case IconName.Calendar:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M1 7H15" strokeLinecap="round" />
            <path
              d="M14.0667 3H1.93333C1.41813 3 1 3.41354 1 3.92308V14.0769C1 14.5865 1.41813 15 1.93333 15H14.0667C14.5819 15 15 14.5865 15 14.0769V3.92308C15 3.41354 14.5819 3 14.0667 3Z"
              strokeLinecap="round"
            />
            <path d="M5 0V3" />
            <path d="M11 0V3" />
          </g>
        ),
      };

    case IconName.Chat:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <path d="M57,6H7a5,5,0,0,0-5,5V41a5,5,0,0,0,5,5H22L32,58,42,46H57a5,5,0,0,0,5-5V11A5,5,0,0,0,57,6Z" />
            <line x1="16" x2="48" y1="20" y2="20" />
            <line x1="16" x2="34" y1="32" y2="32" />
          </g>
        ),
      };

    case IconName.Check:
      return {
        viewBox: '0 0 16 12',
        path: (
          <path
            d="M1 7L5 11L15 1"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.ChevronDown:
      return {
        viewBox: '0 0 12 7',
        path: (
          <path
            d="M1 1L6 6L11 1"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.ChevronLeft:
      return {
        viewBox: '0 0 7 12',
        path: (
          <path
            d="M6 1L1 6L6 11"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.ChevronRight:
      return {
        viewBox: '0 0 7 12',
        path: (
          <path
            d="M1 11L6 6L1 1"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.ChevronUp:
      return {
        viewBox: '0 0 12 7',
        path: (
          <path
            d="M11 6L6 1L1 6"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.Clear:
      return {
        viewBox: '0 0 14 14',
        path: (
          <path d="M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm3.063 8.838l-1.226 1.225L7 8.224l-1.838 1.838-1.224-1.226L5.774 7 3.937 5.162l1.225-1.224L7 5.774l1.838-1.838 1.225 1.225L8.224 7l1.838 1.838z" />
        ),
      };

    case IconName.Close:
      return {
        viewBox: '0 0 12 12',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M11 0.99939L1 10.9994" />
            <path d="M1 0.99939L11 10.9994" />
          </g>
        ),
      };

    case IconName.Crane:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="miter"
            fill="none"
          >
            <rect x="48" y="42" width="12" height="6" />
            <line x1="54" y1="28" x2="54" y2="42" />
            <polyline points="23 23 23 59 14 59 14 23" />
            <line x1="6" y1="59" x2="31" y2="59" />
            <polyline points="27 14 60 17 60 23 4 23 4 16 10 14" strokeLinecap="butt" />
            <line x1="23" y1="23" x2="14" y2="32" strokeLinecap="butt" />
            <line x1="23" y1="41" x2="14" y2="50" strokeLinecap="butt" />
            <line x1="23" y1="41" x2="14" y2="32" strokeLinecap="butt" />
            <line x1="23" y1="59" x2="14" y2="50" strokeLinecap="butt" />
            <polyline points="10 23 10 5 24 5 27 14 27 23" />
            <path d="M16,5v5a4,4,0,0,0,4,4h7" strokeLinecap="butt" />
          </g>
        ),
      };

    case IconName.Dashboard:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="miter"
            fill="none"
          >
            <path d="M34.91 34.76l7.09-12.76" strokeLinecap="butt" />
            <path d="M32 3a29 29 0 1 1 0 58 29 29 0 1 1 0-58z" />
            <path d="M26 40h-14.49a22 22 0 1 1 40.98 0h-14.49" />
            <path d="M32 34a6 6 0 1 1 0 12 6 6 0 1 1 0-12z" />
          </g>
        ),
      };

    case IconName.Decrease:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g>
            <rect height="2" width="8" x="4" y="7" />
            <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z" />
          </g>
        ),
      };

    case IconName.Documents:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="square"
            strokeLinejoin="miter"
            fill="none"
          >
            <path d="M3 19h42v42H3z" />
            <path d="M11 14v-3h42v42h-3" />
            <path d="M19 6V3h42v42h-3" />
          </g>
        ),
      };

    case IconName.Download:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M8 0V11" />
            <path d="M13 6L8 11L3 6" />
            <path d="M15 11V15H1V11" />
          </g>
        ),
      };

    case IconName.Edit:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path
            d="M12 1L15 4L5 14L1 15L2 11L12 1Z"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.EditAddFile:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" fill="none">
            <path d="M40 2v12h12" />
            <path d="M52 30V14L40 2H4v60h48V48" />
            <path d="M43 49l-6 1 1-6 18-18 5 5z" strokeLinecap="square" />
            <path d="M27.6 22.6v16" strokeLinecap="square" />
            <path d="M35.6 30.6h-16" strokeLinecap="square" />
          </g>
        ),
      };

    case IconName.File:
      return {
        viewBox: '0 0 12 15',
        path: (
          <>
            <path d="M7 1V5H11" />
            <g
              strokeWidth={strokeWidth || 2}
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            >
              <path d="M7 1V5H11" />
              <path d="M7 1H1V14H11V5L7 1Z" />
            </g>
          </>
        ),
      };

    case IconName.Flag:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="round" fill="none">
            <polyline points="2.5 1.5 13.5 1.5 11.5 5.5 13.5 9.5 2.5 9.5" />
            <line x1="2.5" x2="2.5" y1="0.5" y2="15.5" />
          </g>
        ),
      };

    case IconName.FlagSolid:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="round">
            <polyline points="2.5 1.5 13.5 1.5 11.5 5.5 13.5 9.5 2.5 9.5" />
            <line x1="2.5" x2="2.5" y1="0.5" y2="15.5" fill="none" />
          </g>
        ),
      };

    case IconName.Folder:
      return {
        viewBox: '0 0 16 14',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          >
            <path d="M6 1L8 3H15V11C15 12.1046 14.1046 13 13 13H3C1.89543 13 1 12.1046 1 11V1H6Z" />
            <path d="M1 3H15V11C15 12.1046 14.1046 13 13 13H3C1.89543 13 1 12.1046 1 11V3Z" />
          </g>
        ),
      };

    case IconName.FolderOpen:
      return {
        viewBox: '0 0 16 13',
        path: (
          <path
            d="M0.5,0.1C0.4,0.2,0.2,0.3,0.2,0.4C0,0.6,0,0.6,0,5.7v5.1l0.2,0.6c0.2,0.8,0.5,1.1,1,1.4L1.5,13l5.3,0c5.9,0,5.7,0,6.4-0.4
          c0.4-0.3,0.9-0.8,1.1-1.2c0.1-0.2,0.5-1.8,0.9-3.5c0.8-3.5,0.8-3.5,0.5-3.9l-0.2-0.2l-0.6,0l-0.6,0l0-0.7l0-0.7l-0.2-0.2l-0.2-0.2
          H7.5L6.7,1c-0.5-0.5-0.9-0.9-1-0.9C5.6,0,4.6,0,3.1,0C1,0,0.7,0,0.5,0.1 M13.9,5.7c0,0.2-1.1,4.9-1.3,5.1c-0.1,0.1-0.2,0.3-0.3,0.3
          c-0.2,0.1-0.5,0.1-5.3,0.1c-4.5,0-5,0-5-0.1c0-0.1,1.2-5.2,1.3-5.4c0-0.1,1.1-0.1,5.3-0.1C13.3,5.6,13.9,5.6,13.9,5.7"
          />
        ),
      };

    case IconName.Fullscreen:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g>
            <polygon points="9,2 12.6,2 8.6,6 10,7.4 14,3.4 14,7 16,7 16,0 9,0 " />
            <polygon points="6,8.6 2,12.6 2,9 0,9 0,16 7,16 7,14 3.4,14 7.4,10 " />
          </g>
        ),
      };

    case IconName.GridMatrix:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <path d="M19.2 6.6v51.2" />
            <path d="M36.3 6.6v51.2" />
            <path d="M2.2 23.7h51.1" />
            <path d="M2.2 40.7h39.2" />
            <path d="M53.3 46.3v11.5H2.2V6.6h51.1v22" />
            <path d="M7 11.5l7.2 7.3" />
            <path d="M14.2 11.5L7 18.8" />
            <path d="M24 11.5l7.2 7.3" />
            <path d="M31.2 11.5L24 18.8" />
            <path d="M24 28.7l7.2 7.2" />
            <path d="M31.2 28.7L24 35.9" />
            <path d="M24 45.8l7.2 7.2" />
            <path d="M31.2 45.8L24 53" />
            <path d="M46.1 45.6l-5.1.9.8-5.1L57.2 26l4.2 4.3z" />
          </g>
        ),
      };

    case IconName.Handover:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} fill="none" strokeLinecap="square">
            <circle cx="11" cy="14" r="7" strokeLinecap="butt" />
            <path d="M28,40C18,35,18,26,10,26a8.18,8.18,0,0,0-8,8V57H18V41" />
            <circle cx="53" cy="14" r="7" strokeLinecap="butt" />
            <path d="M36,40c10-5,10-14,18-14a8.18,8.18,0,0,1,8,8V57H46V41" />
          </g>
        ),
      };

    case IconName.Help:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM9.5 8.4C9 8.7 9 8.8 9 9V10H7V9C7 7.7 7.8 7.1 8.4 6.7C8.9 6.4 9 6.3 9 6C9 5.4 8.6 5 8 5C7.6 5 7.3 5.2 7.1 5.5L6.6 6.4L4.9 5.4L5.4 4.5C5.9 3.6 6.9 3 8 3C9.7 3 11 4.3 11 6C11 7.5 10.1 8 9.5 8.4Z" />
        ),
      };

    case IconName.Hourglass:
      return {
        viewBox: '0 0 14 18',
        path: (
          <>
            <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
              <path d="M0 1H14" />
              <path d="M0 17H14" />
              <path d="M12 1V5L9 9L12 13V17" />
              <path d="M2 1C2 2.33333 2 5 2 5L5 9L2 13V17" />
            </g>
            <path d="M4 14L6.4453 12.3698C6.7812 12.1459 7.2188 12.1459 7.5547 12.3698L10 14V15H4V14Z" />
            <path d="M9.5 4.5L7.81373 6.86077C7.41491 7.41912 6.58509 7.41912 6.18627 6.86077L4.5 4.5H9.5Z" />
          </>
        ),
      };

    case IconName.Info:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9,12H7V7h2V12z M8,6C7.4,6,7,5.6,7,5s0.4-1,1-1 s1,0.4,1,1S8.6,6,8,6z" />
        ),
      };

    case IconName.Increase:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g>
            <polygon points="9,4 7,4 7,7 4,7 4,9 7,9 7,12 9,12 9,9 12,9 12,7 9,7 " />
            <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z" />
          </g>
        ),
      };

    case IconName.Location:
      return {
        viewBox: '0 0 14 18',
        path: (
          <>
            <g fill="white">
              <mask id="location-mask-1">
                <rect x="5" y="5" width="4" height="4" rx="1" />
              </mask>
            </g>
            <g fill="none">
              <path
                d="M12.5 7C12.5 11.5 7 16.5 7 16.5C7 16.5 1.5 11.5 1.5 7C1.5 5.54131 2.07946 4.14236 3.11091 3.11091C4.14236 2.07946 5.54131 1.5 7 1.5C8.45869 1.5 9.85764 2.07946 10.8891 3.11091C11.9205 4.14236 12.5 5.54131 12.5 7V7Z"
                strokeWidth={strokeWidth || 2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="5"
                y="5"
                width="4"
                height="4"
                rx="1"
                strokeWidth={(strokeWidth || 2) * 2 || 4}
                mask="url(#location-mask-1)"
              />
            </g>
          </>
        ),
      };

    case IconName.Locked:
      return {
        viewBox: '0 -1 24 26',
        path: (
          <g strokeWidth={strokeWidth || 2.5} strokeLinecap="square" fill="none">
            <rect height="12" width="18" x="3" y="11" />
            <circle cx="12" cy="17" r="2" />
            <path d="M17,11V6a4.951,4.951,0,0,0-4.9-5H12A4.951,4.951,0,0,0,7,5.9V11" strokeLinecap="butt" />
          </g>
        ),
      };

    case IconName.Magic:
      return {
        viewBox: '0 0 24 24',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <line strokeLinecap="butt" x1="12" x2="15" y1="9" y2="12" />
            <rect
              height="18.4"
              width="4.2"
              transform="matrix(0.7071 0.7071 -0.7071 0.7071 12.8284 -2.9706)"
              x="7.9"
              y="4.8"
            />
            <line x1="15" x2="15" y1="2" y2="1" />
            <line x1="19.9" x2="20.7" y1="4.1" y2="3.3" />
            <line x1="22" x2="23" y1="9" y2="9" />
            <line x1="19.9" x2="20.7" y1="13.9" y2="14.7" />
            <line x1="10.1" x2="9.3" y1="4.1" y2="3.3" />
          </g>
        ),
      };

    case IconName.Merge:
      return {
        viewBox: '0 0 12 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M8 13L11 16" />
            <path d="M2 5L6 1L10 5" />
            <path d="M6 1V11L1 16" />
          </g>
        ),
      };

    case IconName.More:
      return {
        viewBox: '0 0 16 4',
        path: (
          <g>
            <path d="M8 4C9.10457 4 10 3.10457 10 2C10 0.89543 9.10457 0 8 0C6.89543 0 6 0.89543 6 2C6 3.10457 6.89543 4 8 4Z" />
            <path d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z" />
            <path d="M14 4C15.1046 4 16 3.10457 16 2C16 0.89543 15.1046 0 14 0C12.8954 0 12 0.89543 12 2C12 3.10457 12.8954 4 14 4Z" />
          </g>
        ),
      };

    case IconName.NotInterested:
      return {
        viewBox: '0 0 12 12',
        path: (
          <g
            strokeWidth={strokeWidth || 1.5}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          >
            <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" />
            <path d="M2.5 9.5L9.5 2.5" />
          </g>
        ),
      };

    case IconName.Notes:
      return {
        viewBox: '0 0 15 15',
        path: (
          <g>
            <path d="M1 1V13.5L5 9.5H13.5V1H6" />
            <path
              d="M1 1V13.5L5 9.5H13.5V1H6H1Z"
              strokeWidth={strokeWidth || 2}
              strokeLinejoin="round"
              fill="none"
            />
          </g>
        ),
      };

    case IconName.Notifications:
      return {
        viewBox: '0 0 17 17',
        path: (
          <>
            <g strokeWidth={2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" fill="none">
              <path d="M1.5 12H16" />
              <path d="M15 12H15.5C14.395 12 13 11.105 13 10V5.5C13 3.015 10.985 1 8.5 1C6.015 1 4 3.015 4 5.5V10C4 11.105 3.105 12 2 12" />
            </g>
            <path d="M9.5 14C9.5 14.5527 9.05272 15 8.5 15V17C10.1573 17 11.5 15.6573 11.5 14H9.5ZM8.5 15C7.94728 15 7.5 14.5527 7.5 14H5.5C5.5 15.6573 6.84272 17 8.5 17V15Z" />
          </>
        ),
      };

    case IconName.NotificationsSolid:
      return {
        viewBox: '0 0 17 17',
        path: (
          <>
            <path d="M10.5 14C10.5 15.105 9.605 16 8.5 16C7.395 16 6.5 15.105 6.5 14" />
            <path d="M9.5 14C9.5 14.5527 9.05272 15 8.5 15V17C10.1573 17 11.5 15.6573 11.5 14H9.5ZM8.5 15C7.94728 15 7.5 14.5527 7.5 14H5.5C5.5 15.6573 6.84272 17 8.5 17V15Z" />
            <path d="M15 12H15.5C14.395 12 13 11.105 13 10V5.5C13 3.015 10.985 1 8.5 1C6.015 1 4 3.015 4 5.5V10C4 11.105 3.105 12 2 12" />
            <g strokeWidth={2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" fill="none">
              <path d="M1.5 12H16" />
              <path d="M15 12H15.5C14.395 12 13 11.105 13 10V5.5C13 3.015 10.985 1 8.5 1C6.015 1 4 3.015 4 5.5V10C4 11.105 3.105 12 2 12" />
            </g>
          </>
        ),
      };

    case IconName.Packages:
      return {
        viewBox: '0 0 16 15',
        path: (
          <path d="M14,0.8C13.9,0.3,13.5,0,13,0H3C2.5,0,2.1,0.3,2,0.8c0,0-2,7.7-2,8.2v6c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1 V9C16,8.5,14,0.8,14,0.8z M3.8,2h8.4l1.5,6H11c-0.6,0-1,0.4-1,1v2H6V9c0-0.6-0.4-1-1-1H2.3L3.8,2z" />
        ),
      };

    case IconName.Pdf:
      return {
        viewBox: '0 0 16 15',
        path: (
          <g>
            <path d="M9 1V5H13" />
            <path
              d="M9 1V5H13"
              strokeWidth={strokeWidth || 2}
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
            <path d="M9.38462 1L10.1265 0.32946C9.9369 0.119697 9.66736 0 9.38462 0V1ZM3 1V0C2.44772 0 2 0.447715 2 1L3 1ZM13 5H14C14 4.75223 13.908 4.51328 13.7419 4.32946L13 5ZM9.38462 0H3V2H9.38462V0ZM2 1V8H4V1H2ZM14 8V5H12V8H14ZM13.7419 4.32946L10.1265 0.32946L8.64274 1.67054L12.2581 5.67054L13.7419 4.32946Z" />
            <path
              d="M2.96909 9.4H0.729094V15H2.19309V13.056H2.96909C4.57709 13.056 5.13709 12.248 5.13709 11.184C5.13709 10.144 4.57709 9.4 2.96909 9.4ZM3.03309 11.792H2.19309V10.656H3.03309C3.50509 10.656 3.68109 10.872 3.68109 11.224C3.68109 11.632 3.50509 11.792 3.03309 11.792ZM5.85409 15H8.19809C9.97409 15 11.1101 13.872 11.1101 12.2C11.1101 10.528 9.97409 9.4 8.19809 9.4H5.85409V15ZM7.31809 13.656V10.744H8.15809C9.31009 10.744 9.59009 11.032 9.59009 12.2C9.59009 13.368 9.31009 13.656 8.15809 13.656H7.31809ZM15.6435 10.736V9.4H11.9635V15H13.4275V13.04H15.4915V11.704H13.4275V10.736H15.6435Z"
              fill="#3e5df2"
            />
          </g>
        ),
      };

    case IconName.Print:
      return {
        viewBox: '0 0 17 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="M4 4V1H13V4" />
            <path d="M4 13H1V6H16V13H13" />
            <path d="M13 10H4V16H13V10Z" />
          </g>
        ),
      };

    case IconName.Quoted:
      return {
        viewBox: '0 0 8 12',
        path: (
          <g strokeWidth={strokeWidth || 1.5} strokeMiterlimit="10" strokeLinecap="square" fill="none">
            <path d="M3.72754 1V11" />
            <path d="M6.17045 2.8176C5.03409 2.1926 1.45455 1.7267 1.45455 3.87829C1.45455 6.45397 6 5.54488 6 7.81761C6 10.0903 3.04545 9.91988 1 9.18124" />
          </g>
        ),
      };

    case IconName.Quoting:
      return {
        viewBox: '0 0 12 13',
        path: (
          <>
            <g strokeWidth={strokeWidth || 1.5} strokeMiterlimit="10" fill="none">
              <path d="M0.75 12.25H11.25" strokeLinecap="square" />
              <path d="M6.16699 3.19055L8.16699 5.2222" />
            </g>
            <path d="M3.66797 9.79329L3.81729 10.5283L4.04176 10.4827L4.20245 10.3194L3.66797 9.79329ZM1.16797 10.3012L0.432096 10.1563L0.214763 11.2602L1.31729 11.0362L1.16797 10.3012ZM1.66797 7.76164L1.13349 7.23549L0.975579 7.3959L0.932096 7.61676L1.66797 7.76164ZM7.66797 1.66669L8.20245 1.14054C8.06147 0.99733 7.86892 0.916687 7.66797 0.916687C7.46702 0.916687 7.27447 0.99733 7.13349 1.14054L7.66797 1.66669ZM9.66797 3.69834L10.2024 4.22449C10.4898 3.93258 10.4898 3.4641 10.2024 3.17219L9.66797 3.69834ZM3.51865 9.05831L1.01865 9.56622L1.31729 11.0362L3.81729 10.5283L3.51865 9.05831ZM1.90384 10.4461L2.40384 7.90652L0.932096 7.61676L0.432096 10.1563L1.90384 10.4461ZM2.20245 8.28779L8.20245 2.19284L7.13349 1.14054L1.13349 7.23549L2.20245 8.28779ZM7.13349 2.19284L9.13349 4.22449L10.2024 3.17219L8.20245 1.14054L7.13349 2.19284ZM9.13349 3.17219L3.13349 9.26714L4.20245 10.3194L10.2024 4.22449L9.13349 3.17219Z" />
          </>
        ),
      };

    case IconName.Redo:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path d="M15.094,7.031L14.555,0.82l-1.93,1.93C11.353,1.632,9.71,1,8,1C4.14,1,1,4.14,1,8s3.14,7,7,7 c2.491,0,4.814-1.341,6.063-3.499L12.332,10.5C11.439,12.042,9.779,13,8,13c-2.757,0-5-2.243-5-5s2.243-5,5-5 c1.179,0,2.311,0.423,3.205,1.17L8.883,6.492L15.094,7.031z" />
        ),
      };

    case IconName.Reorder:
      return {
        viewBox: '0 -1 21 9',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="m11 7-5-5-5 5" />
            <path d="m10 0 5 5 5-5" />
          </g>
        ),
      };

    case IconName.Replace:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <polyline points="22,40 2,40 2,2 36,2 36,18 " />
            <rect height="38" width="34" x="28" y="24" />
            <path d="M44,10h8c4.418,0,8,3.582,8,8v0" strokeLinecap="butt" />
            <polyline points=" 50,4 44,10 50,16 " />
            <path d="M20,54h-8c-4.418,0-8-3.582-8-8 v0" strokeLinecap="butt" />
            <polyline points=" 14,60 20,54 14,48 " />
          </g>
        ),
      };

    case IconName.RulerPencil:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <line x1="50" x2="50" y1="12" y2="48" />
            <line x1="40" x2="60" y1="12" y2="12" />
            <line strokeLinecap="butt" x1="40" x2="60" y1="48" y2="48" />
            <polygon points="60,48 50,60 40,48 40,2 60,2 " />
            <line strokeLinecap="butt" x1="4" x2="13" y1="30" y2="30" />
            <line strokeLinecap="butt" x1="4" x2="11" y1="38" y2="38" />
            <line strokeLinecap="butt" x1="4" x2="11" y1="54" y2="54" />
            <line strokeLinecap="butt" x1="4" x2="13" y1="14" y2="14" />
            <line strokeLinecap="butt" x1="4" x2="11" y1="22" y2="22" />
            <line strokeLinecap="butt" x1="4" x2="13" y1="46" y2="46" />
            <circle cx="20" cy="10" r="2" />
            <rect height="60" width="24" x="4" y="2" />
          </g>
        ),
      };

    case IconName.Search:
      return {
        viewBox: '0 0 17 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path
              d="M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
              strokeLinecap="round"
            />
            <path d="M16 16L11 11" />
          </g>
        ),
      };

    case IconName.SearchContent:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <line x1="22" x2="4" y1="24" y2="24" />
            <line x1="22" x2="4" y1="40" y2="40" />
            <line x1="42" x2="4" y1="56" y2="56" />
            <line x1="42" x2="4" y1="8" y2="8" />
            <circle cx="42" cy="32" r="12" />
            <line x1="60" x2="50.485" y1="50" y2="40.485" />
          </g>
        ),
      };

    case IconName.Send:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="square" fill="none">
            <polyline points="60 5 17 36.244 17 58 27 51" strokeLinecap="butt" />
            <polygon points="4 27 60 5 49 59 4 27" />
          </g>
        ),
      };

    case IconName.Settings:
      return {
        viewBox: '0 0 17 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M8.24512 11C9.62583 11 10.7451 9.88071 10.7451 8.5C10.7451 7.11929 9.62583 6 8.24512 6C6.86441 6 5.74512 7.11929 5.74512 8.5C5.74512 9.88071 6.86441 11 8.24512 11Z" />
            <path d="M13.745 8.5C13.745 8.035 13.681 7.587 13.573 7.156L15.49 6.049L13.99 3.451L12.075 4.557C11.431 3.931 10.634 3.464 9.745 3.213V1H6.745V3.212C5.857 3.464 5.06 3.931 4.415 4.557L2.5 3.451L1 6.049L2.917 7.156C2.809 7.587 2.745 8.035 2.745 8.5C2.745 8.964 2.809 9.413 2.917 9.844L1 10.951L2.5 13.549L4.416 12.443C5.06 13.069 5.857 13.536 6.746 13.787V16H9.746V13.788C10.635 13.536 11.431 13.069 12.076 12.444L13.992 13.55L15.492 10.952L13.575 9.845C13.681 9.413 13.745 8.964 13.745 8.5Z" />
          </g>
        ),
      };

    case IconName.Star:
      return {
        viewBox: '-1 -1 16 16',
        path: (
          <path
            d="M7.00016 0.660156L9.06016 4.83349L13.6668 5.50282L10.3335 8.75216L11.1202 13.3402L7.00016 11.1748L2.88016 13.3402L3.66683 8.75216L0.333496 5.50282L4.94016 4.83349L7.00016 0.660156Z"
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
            fill="none"
          />
        ),
      };

    case IconName.StarSolid:
      return {
        viewBox: '-1 -1 16 16',
        path: (
          <path
            d="M7.00016 0.660156L9.06016 4.83349L13.6668 5.50282L10.3335 8.75216L11.1202 13.3402L7.00016 11.1748L2.88016 13.3402L3.66683 8.75216L0.333496 5.50282L4.94016 4.83349L7.00016 0.660156Z"
            strokeWidth={2}
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
        ),
      };

    case IconName.ToolHand:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path d="M15,2a1,1,0,0,0-1,1V7a.5.5,0,0,1-.5.5h0A.5.5,0,0,1,13,7V1.553a1.037,1.037,0,0,0-.832-1.04A1,1,0,0,0,11,1.5V7a.5.5,0,0,1-.5.5h0A.5.5,0,0,1,10,7V1.053A1.037,1.037,0,0,0,9.168.014,1,1,0,0,0,8,1V7a.5.5,0,0,1-.5.5h0A.5.5,0,0,1,7,7V1.553A1.037,1.037,0,0,0,6.168.514,1,1,0,0,0,5,1.5V9.293a.5.5,0,0,1-.854.354l-2-2A1.081,1.081,0,0,0,.911,7.4,1.032,1.032,0,0,0,.469,8.834L2.78,12.942A6,6,0,0,0,8.009,16H10a6,6,0,0,0,6-6V3a1,1,0,0,0-1-1Z" />
        ),
      };

    case IconName.Tools:
      return {
        viewBox: '0 0 64 64',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeLinecap="square"
            strokeLinejoin="miter"
            strokeMiterlimit="10"
            fill="none"
          >
            <path d="M44.438,34.531,56.352,45a8.034,8.034,0,0,1,.575,11.347c-.091.1-.184.2-.28.3h0a8.035,8.035,0,0,1-11.363,0c-.1-.1-.189-.2-.28-.3L34.8,45.23" />
            <polyline
              points="30.608 26.608 20 16 20 12 13 5 5 13 12 20 16 20 26.29 30.29"
              strokeLinecap="butt"
            />
            <path d="M60.9,23.1,45.1,7.3A11.468,11.468,0,0,0,29,7.3L52.8,31.1Z" />
            <path
              d="M40.163,18.462,5.412,48.089a4,4,0,0,0-.24,5.879l4.86,4.86a4,4,0,0,0,5.879-.24L45.579,23.879"
              strokeLinecap="butt"
            />
          </g>
        ),
      };

    case IconName.Undo:
      return {
        viewBox: '0 0 16 16',
        path: (
          <path d="M0.91 7.03l0.54-6.21 1.93 1.93a7.01 7.01 0 0 1 4.62-1.75c3.86 0 7 3.14 7 7s-3.14 7-7 7a7.03 7.03 0 0 1-6.06-3.5l1.73-1a5.02 5.02 0 0 0 4.33 2.5c2.76 0 5-2.24 5-5s-2.24-5-5-5c-1.18 0-2.31 0.42-3.21 1.17l2.33 2.32-6.21 0.54z" />
        ),
      };

    case IconName.Unlocked:
      return {
        viewBox: '0 -1 24 26',
        path: (
          <g strokeWidth={strokeWidth || 2.5} strokeLinecap="square" fill="none">
            <rect height="12" width="18" x="3" y="11" />
            <circle cx="12" cy="17" r="2" />
            <path d="M17,6a4.951,4.951,0,0,0-4.9-5H12A4.951,4.951,0,0,0,7,5.9V11" strokeLinecap="butt" />
          </g>
        ),
      };

    case IconName.Update:
      return {
        viewBox: '0 0 16 16',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M1.5 7.99999C1.49974 6.59393 1.95542 5.22569 2.79867 4.10055C3.64193 2.97541 4.82729 2.15404 6.17692 1.75968C7.52655 1.36531 8.96766 1.41922 10.2841 1.9133C11.6005 2.40738 12.7212 3.315 13.478 4.49999" />
            <path d="M14.5 1.5V5.5H10.5" />
            <path d="M14.5005 8C14.5007 9.40606 14.045 10.7743 13.2018 11.8994C12.3585 13.0246 11.1732 13.8459 9.82354 14.2403C8.47391 14.6347 7.0328 14.5808 5.7164 14.0867C4.4 13.5926 3.27931 12.685 2.52246 11.5" />
            <path d="M1.5 14.4998V10.4998H5.5" />
          </g>
        ),
      };

    case IconName.Upload:
      return {
        viewBox: '0 0 16 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeMiterlimit="10" strokeLinejoin="round" fill="none">
            <path d="M8 1V12" />
            <path d="M3 6L8 1L13 6" />
            <path d="M15 12V16H1V12" />
          </g>
        ),
      };

    case IconName.User:
      return {
        viewBox: '0 0 15 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinecap="round" strokeLinejoin="round" fill="none">
            <path d="M9 11H6C4.67392 11 3.40215 11.5268 2.46447 12.4645C1.52678 13.4021 1 14.6739 1 16H14C14 15.3434 13.8707 14.6932 13.6194 14.0866C13.3681 13.48 12.9998 12.9288 12.5355 12.4645C12.0712 12.0002 11.52 11.6319 10.9134 11.3806C10.3068 11.1293 9.65661 11 9 11V11Z" />
            <path d="M7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z" />
          </g>
        ),
      };

    case IconName.UserAdd:
      return {
        viewBox: '0 0 16 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="M9 11H6C4.67392 11 3.40215 11.5268 2.46447 12.4645C1.52678 13.4021 1 14.6739 1 16H10" />
            <path
              d="M7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z"
              strokeLinecap="round"
            />
            <path d="M13 10V16" />
            <path d="M10 13H16" />
          </g>
        ),
      };

    case IconName.UserDelete:
      return {
        viewBox: '0 0 16 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="M9,11H6c-1.3,0-2.6,0.5-3.5,1.5C1.5,13.4,1,14.7,1,16h8" />
            <path d="M7.5,8C9.4,8,11,6.4,11,4.5S9.4,1,7.5,1S4,2.6,4,4.5S5.6,8,7.5,8z" />
            <path d="M10.9,10.9l4.2,4.2" />
            <path d="M10.9,15.1l4.2-4.2" />
          </g>
        ),
      };

    case IconName.UserEdit:
      return {
        viewBox: '0 0 16 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="m8 11h-2c-1.3 0-2.6.5-3.5 1.5-1 .9-1.5 2.2-1.5 3.5h5" />
            <path d="m7.5 8c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5z" />
            <path d="m11 15-2.5.5.5-2.5 4.5-4.5 2 2z" />
          </g>
        ),
      };

    case IconName.UserRemove:
      return {
        viewBox: '0 0 15 17',
        path: (
          <g strokeWidth={strokeWidth || 2} strokeLinejoin="round" fill="none">
            <path d="M9 11H6C4.67392 11 3.40215 11.5268 2.46447 12.4645C1.52678 13.4021 1 14.6739 1 16H10" />
            <path
              d="M7.5 8C9.433 8 11 6.433 11 4.5C11 2.567 9.433 1 7.5 1C5.567 1 4 2.567 4 4.5C4 6.433 5.567 8 7.5 8Z"
              strokeLinecap="round"
            />
            <path d="M11 13H15" />
          </g>
        ),
      };

    case IconName.View:
      return {
        viewBox: '0 0 18 14',
        path: (
          <g
            strokeWidth={strokeWidth || 2}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          >
            <path d="M1.5 7C1.5 7 4.5 1.5 9 1.5C13.5 1.5 16.5 7 16.5 7C16.5 7 13.5 12.5 9 12.5C4.5 12.5 1.5 7 1.5 7Z" />
            <path d="M9 9.5C10.3807 9.5 11.5 8.38071 11.5 7C11.5 5.61929 10.3807 4.5 9 4.5C7.61929 4.5 6.5 5.61929 6.5 7C6.5 8.38071 7.61929 9.5 9 9.5Z" />
          </g>
        ),
      };

    default:
      return undefined;
  }
};
